// T15-D8 — these are the STORED submission values (`submissionValue`) of the
// one canonical server list, `REGION_DEFINITIONS` in src/lib/regions.ts
// (served at GET /api/v1/regions). Parity — values and order — is pinned by
// tests/lib/regions-canonical-list.test.ts; change the server list first.
export const REGIONS = [
  'FDA',
  'EMA',
  'MHRA',
  'Health Canada',
  'PMDA',
  'TGA',
  'Swissmedic',
] as const;

export type Region = (typeof REGIONS)[number];

export const REGION_FLAGS: Readonly<Record<Region, string>> = Object.freeze({
  FDA: '🇺🇸',
  EMA: '🇪🇺',
  MHRA: '🇬🇧',
  'Health Canada': '🇨🇦',
  PMDA: '🇯🇵',
  TGA: '🇦🇺',
  Swissmedic: '🇨🇭',
});
